import { ResourceManagementDashboardComponent } from './all-dashboards/resource-management-dashboard/resource-management-dashboard.component';
import { ServicesDashboardModule } from './all-dashboards/services-dashboard/services-dashboard.module';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './_guards/auth.guard';


const routes: Routes = [
  {
    path: 'app',
    loadChildren: () => import('./main/main.module').then(m => m.PlanworkMainModule),

  },
  {
    path: 'company-list',
    loadChildren: () => import('./register-company/register-company.module').then(m => m.RegisterCompanyModule),

  },

  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'time-out',
    loadChildren: () => import('./time-out/time-out.module').then(m => m.TimeOutModule),

  },
  {
    path: 'my-approval',
    loadChildren: () => import('./main/my-approval/my-approval.module').then(m => m.MyapprovalModule),

  },
  {
    path: 'my-requisition',
    loadChildren: () => import('./main/my-requisition/my-requisition.module').then(m => m.MyRequisitionModule),

  },
  {
    path: 'asset-management',
    loadChildren: () => import('./main/asset-management/asset-management.module').then(m => m.AssetManagementModule),

  },
  {
    path: 'payment/petty-cash',
    loadChildren: () => import('./main/petty-cash/petty-cash.module').then(m => m.PettyCashModule),

},
  {
    path: 'repair-maintenance',
    loadChildren: () => import('./main/repair-maintenance/repair-maintenance.module').then(m => m.RepairMaintenanceModule),

  },
  {
    path: 'consumable',
    loadChildren: () => import('./main/consumable/consumable.module').then(m => m.ConsumableModule),

  },
  {
    path: 'my-reimbursement',
    loadChildren: () => import('./main/my-reimbursement/my-reimbursement.module').then(m => m.MyReimbursementModule),

  },
  {
    path: 'payment',
    loadChildren: () => import('./main/payment/payment.module').then(m => m.PaymentModule),

  },
    {
    path: 'payroll',
    loadChildren: () => import('./main/payroll/payroll.module').then(m => m.PayrollModule),

  },
  {
    path: 'accounts',
    loadChildren: () => import('./main/accounts/accounts.module').then(m => m.AccountsModule),

  },
  {
    path: 'purchase-and-procurement',
    loadChildren: () => import('./main/purchase-and-procurement/purchase-and-procurement.module').then(m => m.PurchaseAndProcurementModule),

  },
    {
      path: 'crm',
      loadChildren: () => import('./all-dashboards/crm-dashboard/crm-dashboard.module').then(m => m.CRMDashboardModule),
      canActivate: [AuthGuard]
    },
     {
      path: 'license',
      loadChildren: () => import('./all-dashboards/license-dashboard/license-dashboard.module').then(m => m.LicenseDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'process',
      loadChildren: () => import('./all-dashboards/process-dashboard/process-dashboard.module').then(m => m.ProcessDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'project',
      loadChildren: () => import('./all-dashboards/project-dashboard/project-dashboard.module').then(m => m.ProjectDashboardModule),
      canActivate: [AuthGuard]
    },
     {
      path: 'services',
      loadChildren: () => import('./all-dashboards/services-dashboard/services-dashboard.module').then(m => m.ServicesDashboardModule),
      canActivate: [AuthGuard]
    },
     {
      path: 'products',
      loadChildren: () => import('./all-dashboards/products-dashboard/products-dashboard.module').then(m => m.ProductsDashboardModule),
      canActivate: [AuthGuard]
    },
     {
      path: 'traders-suppply',
      loadChildren: () => import('./all-dashboards/traders-suppply-dashboard/traders-suppply-dashboard.module').then(m => m.TradersSuppplyDashboardModule),
      canActivate: [AuthGuard]
    },
     {
      path: 'hr',
      loadChildren: () => import('./all-dashboards/hr-dashboard/hr-dashboard.module').then(m => m.HrDashboardModule),
      canActivate: [AuthGuard]
    },
     {
      path: 'asset',
      loadChildren: () => import('./all-dashboards/assets-dashboard/assets-dashboard.module').then(m => m.AssetsDashboardModule),
      canActivate: [AuthGuard]
    },
     {
      path: 'purchase',
      loadChildren: () => import('./all-dashboards/purchase-and-procurement-dashboard/purchase-and-procurement-dashboard.module').then(m => m.PurchaseAndProcurementDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'policies',
      loadChildren: () => import('./all-dashboards/policies-dashboard/policies-dashboard.module').then(m => m.PoliciesDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'consumable',
      loadChildren: () => import('./all-dashboards/consumables-dashboard/consumables-dashboard.module').then(m => m.ConsumablesDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'digital-assets',
      loadChildren: () => import('./all-dashboards/digital-assets-dashboard/digital-assets-dashboard.module').then(m => m.DigitalAssetsDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'inventory',
      loadChildren: () => import('./all-dashboards/inventory-dashboard/inventory-dashboard.module').then(m => m.InventoryDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'facility',
      loadChildren: () => import('./all-dashboards/facility-dashboard/facility-dashboard.module').then(m => m.FacilityDashboardModule),
      canActivate: [AuthGuard]
    },
     {
      path: 'finance',
      loadChildren: () => import('./all-dashboards/finance-dashboard/finance-dashboard.module').then(m => m.FinanceDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'reports',
      loadChildren: () => import('./all-dashboards/reports-dashboard/reports-dashboard.module').then(m => m.ReportsDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'docprint',
      loadChildren: () => import('./all-dashboards/documents-dashboard/documents-dashboard.module').then(m => m.DocumentsDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'resource-management',
      loadChildren: () => import('./all-dashboards/resource-management-dashboard/resource-management-dashboard.module').then(m => m.ResourceManagementDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'supply-chain-management',
      loadChildren: () => import('./all-dashboards/supply-chain-dashboard/supply-chain-dashboard.module').then(m => m.SupplyChainDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'service-utility',
      loadChildren: () => import('./all-dashboards/service-and-utility-dashboard/service-and-utility-dashboard.module').then(m => m.ServiceAndUtilityDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'vendors',
      loadChildren: () => import('./all-dashboards/vendor-management-dashboard/vendor-management-dashboard.module').then(m => m.VendorManagementDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'company',
      loadChildren: () => import('./all-dashboards/company-setup-dashboard/company-setup-dashboard.module').then(m => m.CompanySetupDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'vendors',
      loadChildren: () => import('./all-dashboards/vendor-management-dashboard/vendor-management-dashboard.module').then(m => m.VendorManagementDashboardModule),
      canActivate: [AuthGuard]
    },
      {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
      path: 'subscription',
      loadChildren: () => import('./all-dashboards/subscription-dashboard/subscription-dashboard.module').then(m => m.SubscriptionDashboardModule),
      canActivate: [AuthGuard]
    },
    {
      path: 'staffing',
      loadChildren: () => import('./all-dashboards/staffing-dashboard/staffing-dashboard.module').then(m => m.StaffingDashboardModule),
      canActivate: [AuthGuard]
    },
  {
    path: '**',
    redirectTo: '/',

  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
